import { authFetch } from 'auth/utils';
import { Mno } from './mnoApi.types';
import { envVariables } from 'src/common/utils/envVariables';
import { MnosDTO, MnosFilters } from 'src/common/components/Filters/Inputs/mnos/models/mnos';
import { mapKeys, omitBy, upperFirst } from 'lodash';
import qs from 'qs';

const prepareMnosQuery = (filters?: MnosFilters) => {
  if (!filters) {
    return '';
  }

  const cleanedFilters = omitBy(filters, (value) => {
    return !value;
  });

  const searchParams = mapKeys(cleanedFilters, (_, key) => upperFirst(key)) as Record<
    string,
    string
  >;

  return qs.stringify(searchParams);
};

export const fetchMnos = async (filters?: MnosFilters, signal?: AbortSignal) => {
  const urlQuery = prepareMnosQuery(filters);
  const mnosResponse = await authFetch(
    `${envVariables.VITE_SIM_INVENTORY_MOBILE_NETWORK_OPERATORS_API}?${urlQuery.toString()}`,
    { signal },
  );

  const mnos: MnosDTO = await mnosResponse.json();
  return mnos.items;
};

export const fetchMno = async (ccii?: string, signal?: AbortSignal) => {
  const mnoResponse = await authFetch(
    `${envVariables.VITE_SIM_INVENTORY_MOBILE_NETWORK_OPERATORS_API}/${ccii}`,
    { signal },
  );

  const mno: Mno = await mnoResponse.json();
  return mno;
};
